import { FinalRecommendation } from 'utils/typedEnums';

export const CandidateFeedbackFinalRecommendation = {
  YES: 'yes',
  MAYBE: 'maybe',
  NO: 'no',
} as const;

export const CandidateFeedbackListModalPane = {
  SCORECARD_LIST: 'scorecardList',
  REFERENCE_LIST: 'referenceList',
  SCORECARD_CREATE: 'scorecardCreate',
  REFERENCE_CREATE: 'referenceCreate',
  SCORECARD_EDIT: 'scorecardEdit',
  REFERENCE_EDIT: 'referenceEdit',
  SCORECARD_VIEW: 'scorecardView',
  REFERENCE_VIEW: 'referenceView',
} as const;

export const ConnectHiringRequestAction = {
  scorecard: 'scorecard',
  reference: 'reference',
  application: 'application',
} as const;

export const hiringRequestContactTypes = {
  phone: 'Phone call',
  email: 'Email',
  virtual: 'Virtual interview',
  onsite: 'Onsite interview',
} as const;

export const HiringRequestToast = {
  ERROR: 'error',
  SUCCESS: 'success',
} as const;

export const LongCandidateFeedbackFinalRecommendation = {
  YES: 'final_recommendation/yes',
  MAYBE: 'final_recommendation/maybe',
  NO: 'final_recommendation/no',
} as const;

export const CandidateFeedbackModalTypes = {
  APPLICATION: 'application',
  CANDIDATE: 'candidate',
  SCORECARD: 'scorecard',
  REFERENCE: 'reference',
} as const;

export const finalRecommendationMap = {
  yes: FinalRecommendation.YES,
  maybe: FinalRecommendation.MAYBE,
  no: FinalRecommendation.NO,
};

export const candidateFeedbackToasts = {
  referenceSuccess: 'Reference check submitted',
  referenceUpdated: 'Reference check updated',
  referenceDraft: 'Reference check saved as draft',
  referenceRequest: 'Reference check request sent',
  referenceContact: 'Reference contact saved',
  scorecardSuccess: 'Scorecard submitted',
  scorecardUpdated: 'Scorecard updated',
  scorecardDraft: 'Scorecard saved as draft',
} as const;
